module.exports = __webpack_public_path__ + "img/20210906-1630913579971489.4b524e63.png";